
export default function ProductsSection() {
  const products = [
    {
      category: "Educational Toy",
      description: "Interactive learning toys that promote cognitive development and educational growth",
      image: "https://public.readdy.ai/ai/img_res/51a0f4d27041f4a37d78688437bd5180.jpg",
      items: ["Interactive Learning Tablets", "Smart Building Blocks", "STEM Robotics Kits", "Electronic Learning Boards", "Digital Puzzle Games"]
    },
    {
      category: "Electronic Plastic Toy",
      description: "High-quality electronic toys combining plastic construction with advanced technology",
      image: "https://readdy.ai/api/search-image?query=Modern%20electronic%20plastic%20toys%20featuring%20remote%20control%20cars%20with%20LED%20lights%2C%20electronic%20action%20figures%20with%20sound%20effects%2C%20interactive%20plastic%20robots%2C%20electronic%20musical%20instruments%20for%20kids%2C%20and%20smart%20toy%20vehicles%20on%20contemporary%20white%20background%2C%20sleek%20modern%20design&width=600&height=400&seq=electronic1&orientation=landscape",
      items: ["Remote Control Vehicles", "Electronic Action Figures", "Interactive Robots", "Musical Electronic Toys", "Smart Toy Vehicles"]
    },
    {
      category: "Hobby/Model Construction",
      description: "Precision model kits and construction sets for hobbyists and collectors",
      image: "https://readdy.ai/api/search-image?query=Premium%20hobby%20model%20construction%20kits%20including%20detailed%20airplane%20models%2C%20architectural%20building%20sets%2C%20precision%20car%20model%20kits%2C%20ship%20construction%20models%2C%20and%20advanced%20mechanical%20building%20systems%20displayed%20on%20modern%20workspace%20with%20professional%20lighting%2C%20sophisticated%20hobby%20products&width=600&height=400&seq=hobby1&orientation=landscape",
      items: ["Airplane Model Kits", "Architectural Building Sets", "Car Model Kits", "Ship Construction Models", "Mechanical Building Systems"]
    },
    {
      category: "Electronic Games",
      description: "Cutting-edge electronic gaming devices and interactive entertainment systems",
      image: "https://readdy.ai/api/search-image?query=Modern%20electronic%20gaming%20devices%20including%20handheld%20gaming%20consoles%2C%20interactive%20gaming%20tablets%2C%20electronic%20board%20games%20with%20digital%20displays%2C%20smart%20gaming%20controllers%2C%20and%20portable%20gaming%20systems%20arranged%20on%20sleek%20contemporary%20surface%20with%20ambient%20lighting%2C%20high-tech%20gaming%20products&width=600&height=400&seq=games1&orientation=landscape",
      items: ["Handheld Gaming Consoles", "Interactive Gaming Tablets", "Electronic Board Games", "Smart Gaming Controllers", "Portable Gaming Systems"]
    },
    {
      category: "Hi-tech Toy",
      description: "Advanced technology toys featuring AI, sensors, and smart connectivity",
      image: "https://readdy.ai/api/search-image?query=Cutting-edge%20hi-tech%20toys%20including%20AI-powered%20robots%2C%20smart%20drones%20with%20cameras%2C%20augmented%20reality%20toys%2C%20voice-controlled%20devices%2C%20and%20IoT%20connected%20toys%20displayed%20on%20futuristic%20white%20background%20with%20modern%20lighting%2C%20advanced%20technology%20products&width=600&height=400&seq=hitech1&orientation=landscape",
      items: ["AI-Powered Robots", "Smart Drones", "Augmented Reality Toys", "Voice-Controlled Devices", "IoT Connected Toys"]
    },
    {
      category: "Non-Electronic Plastic Toy",
      description: "Traditional plastic toys focusing on creativity, imagination, and physical play",
      image: "https://readdy.ai/api/search-image?query=Modern%20non-electronic%20plastic%20toys%20including%20colorful%20building%20blocks%2C%20action%20figures%2C%20toy%20vehicles%2C%20dollhouses%2C%20and%20creative%20play%20sets%20arranged%20on%20clean%20white%20surface%20with%20bright%20professional%20lighting%2C%20contemporary%20plastic%20toy%20design%2C%20vibrant%20colors&width=600&height=400&seq=plastic1&orientation=landscape",
      items: ["Building Block Sets", "Action Figures", "Toy Vehicles", "Dollhouses", "Creative Play Sets"]
    }
  ];

  return (
    <section id="products" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Our Product Categories
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We specialize in sourcing and exporting high-quality toys across multiple categories, 
            ensuring the best value for our international partners.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((product, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="aspect-video overflow-hidden">
                <img 
                  src={product.image} 
                  alt={product.category}
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {product.category}
                </h3>
                <p className="text-gray-600 mb-4 text-sm">
                  {product.description}
                </p>
                <div className="space-y-2">
                  <h4 className="font-semibold text-gray-900 mb-2 text-sm">Featured Items:</h4>
                  <div className="grid grid-cols-1 gap-1">
                    {product.items.map((item, itemIndex) => (
                      <div key={itemIndex} className="flex items-center text-gray-700 text-sm">
                        <i className="ri-check-line text-green-600 mr-2 text-xs"></i>
                        <span>{item}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <div className="bg-white rounded-2xl shadow-lg p-8 max-w-2xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Custom Product Sourcing
            </h3>
            <p className="text-gray-600 mb-6">
              Looking for specific toys not listed here? We offer custom sourcing services 
              to meet your unique requirements with competitive pricing and reliable quality.
            </p>
            <button 
              onClick={() => {
                const element = document.getElementById('contact');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-red-600 text-white px-8 py-3 rounded-lg hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-message-line mr-2"></i>
              Request Custom Quote
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
